import {IUserOrganizationSettingData} from '@/utils/types';
import {IAdminNotificationSettingReducer} from '@/utils/types/superAdmin.interface';
import {PayloadAction} from '@reduxjs/toolkit';
//types

export const pendingOperation = (state: IAdminNotificationSettingReducer) => {
	state.isLoading = true;
};

export const rejectedOperation = (state: IAdminNotificationSettingReducer) => {
	state.isLoading = false;
};

export const getNotificationSetting = (
	state: IAdminNotificationSettingReducer,
	{payload}: PayloadAction<IUserOrganizationSettingData>
) => {
	state.adminSetting = payload;
	state.isLoading = false;
};

export const updateNotificationSetting = (
	state: IAdminNotificationSettingReducer,
	{payload}: PayloadAction<IUserOrganizationSettingData>
) => {
	state.adminSetting = payload;
	state.isLoading = false;
};
